import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router'
import vueWechatTitle from 'vue-wechat-title'
import VueClipBoard from 'vue-clipboard2'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAMap from 'vue-amap';
import axios from 'axios';
import store from './store'
// 自动退出文件路径
import auto_loginout from '@/utills/auto_loginout.js'
Vue.use(auto_loginout)
Vue.config.productionTip = false

Vue.prototype.$axios = axios

Vue.use(VueAMap);
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(vueWechatTitle)
Vue.use(VueClipBoard)
// Vue.use(Router)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


VueAMap.initAMapApiLoader({
  //申请地址 https://lbs.amap.com/ 选择web端jsAPI
  key: '16b4bf93e840d94a18455a2903a97090',
  // 插件集合，用到什么插件就使用什么插件
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '1.4.4', // 高德sdk版本，最新的sdk已经出到了2.0
  //官网解释：JSAPI 2.0 提供的开发接口与 1.4 版本达到 99%的兼容度，但是为了保证插件的稳定性我们还是选择1.4.4。
}) 
